import { Controller } from '@hotwired/stimulus'
import { copyToClipboard } from '../../services'

export default class extends Controller {
  static outlets = ['project-toolbar--verdicts-dialog']

  declare readonly hasProjectToolbarVerdictsDialogOutlet: boolean
  declare readonly projectToolbarVerdictsDialogOutlet: Controller & { open(params: { name?: string; canEnable?: boolean; editUrl?: string }): void }

  private boundHandleClipboardClick!: (event: Event) => void
  private boundHandleVerdictsClick!: (event: Event) => void

  connect() {
    this.boundHandleClipboardClick = this.handleClipboardClick.bind(this)
    this.boundHandleVerdictsClick = this.handleVerdictsClick.bind(this)
    this.element.addEventListener('click', this.boundHandleClipboardClick)
    this.element.addEventListener('click', this.boundHandleVerdictsClick)
  }

  disconnect() {
    this.element.removeEventListener('click', this.boundHandleClipboardClick)
    this.element.removeEventListener('click', this.boundHandleVerdictsClick)
  }

  async handleClipboardClick(event: Event) {
    const clipboardButton = (event.target as HTMLElement).closest('[data-clipboard-url]') as HTMLElement | null
    if (!clipboardButton) return

    event.preventDefault()

    const url = clipboardButton.dataset.clipboardUrl
    const label = clipboardButton.textContent?.trim()
    if (!url || !label) return

    try {
      await copyToClipboard(url)
      showMessageToast('green', `The link to ${label} has been copied to your clipboard`)
    } catch {
      showMessageToast('red', 'Failed to copy link')
    }
  }

  handleVerdictsClick(event: Event) {
    const btn = (event.target as HTMLElement).closest('[data-verdicts-target="item"]') as HTMLElement | null
    if (!btn) return

    event.preventDefault()

    if (!this.hasProjectToolbarVerdictsDialogOutlet) return

    this.projectToolbarVerdictsDialogOutlet.open({
      name: btn.dataset.storyCategoryName,
      canEnable: btn.dataset.canEnableVerdicts === 'true',
      editUrl: btn.dataset.editUrl
    })
  }
}
